import TradingDeskActionTypes from './tradingDeskV2-types'

const INITIAL_STATE = {
    loader: null,
    success: null,
    error: null,
    tradingDeskExchangeRate: null,
    tradingDeskExchangeFee: null,
    maxValueFee: null,
}

const tradingDeskV2Reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TradingDeskActionTypes.START_ACCOUNT_DEPOSIT: {
            return {
                ...state,
                loader: { ...state.loader, ACCOUNT_DEPOSIT: true },
            }
        }
        case TradingDeskActionTypes.SUCCESS_ACCOUNT_DEPOSIT: {
            return {
                ...state,
                loader: { ...state.loader, ACCOUNT_DEPOSIT: null },
                success: { ...state.success, ACCOUNT_DEPOSIT: true },
                error: { ...state.success, ACCOUNT_DEPOSIT: null },
            }
        }
        case TradingDeskActionTypes.FINISH_ACCOUNT_DEPOSIT: {
            return {
                ...state,
                loader: { ...state.loader, ACCOUNT_DEPOSIT: null },
                success: { ...state.success, ACCOUNT_DEPOSIT: null },
                error: { ...state.success, ACCOUNT_DEPOSIT: null },
            }
        }
        case TradingDeskActionTypes.FAILURE_ACCOUNT_DEPOSIT: {
            return {
                ...state,
                loader: { ...state.loader, ACCOUNT_DEPOSIT: null },
                success: { ...state.success, ACCOUNT_DEPOSIT: null },
                error: { ...state.success, ACCOUNT_DEPOSIT: true },
            }
        }

        case TradingDeskActionTypes.START_ACCOUNT_WITHDRAW: {
            return {
                ...state,
                loader: { ...state.loader, ACCOUNT_WITHDRAW: true },
            }
        }
        case TradingDeskActionTypes.SUCCESS_ACCOUNT_WITHDRAW: {
            return {
                ...state,
                loader: { ...state.loader, ACCOUNT_WITHDRAW: null },
                success: { ...state.success, ACCOUNT_WITHDRAW: true },
                error: { ...state.success, ACCOUNT_WITHDRAW: null },
            }
        }
        case TradingDeskActionTypes.FINISH_ACCOUNT_WITHDRAW: {
            return {
                ...state,
                loader: { ...state.loader, ACCOUNT_WITHDRAW: null },
                success: { ...state.success, ACCOUNT_WITHDRAW: null },
                error: { ...state.success, ACCOUNT_WITHDRAW: null },
            }
        }
        case TradingDeskActionTypes.FAILURE_ACCOUNT_WITHDRAW: {
            return {
                ...state,
                loader: { ...state.loader, ACCOUNT_WITHDRAW: null },
                success: { ...state.success, ACCOUNT_WITHDRAW: null },
                error: { ...state.success, ACCOUNT_WITHDRAW: true },
            }
        }

        case TradingDeskActionTypes.START_ADD_ACCOUNT: {
            return {
                ...state,
                loader: { ...state.loader, ADD_ACCOUNT: true },
            }
        }
        case TradingDeskActionTypes.SUCCESS_ADD_ACCOUNT: {
            return {
                ...state,
                loader: { ...state.loader, ADD_ACCOUNT: null },
                success: { ...state.success, ADD_ACCOUNT: true },
                error: { ...state.success, ADD_ACCOUNT: null },
            }
        }
        case TradingDeskActionTypes.FINISH_ADD_ACCOUNT: {
            return {
                ...state,
                loader: { ...state.loader, ADD_ACCOUNT: null },
                success: { ...state.success, ADD_ACCOUNT: null },
                error: { ...state.success, ADD_ACCOUNT: null },
            }
        }
        case TradingDeskActionTypes.FAILURE_ADD_ACCOUNT: {
            return {
                ...state,
                loader: { ...state.loader, ADD_ACCOUNT: null },
                success: { ...state.success, ADD_ACCOUNT: null },
                error: { ...state.success, ADD_ACCOUNT: true },
            }
        }

        case TradingDeskActionTypes.START_EXCHANGE: {
            return {
                ...state,
                loader: { ...state.loader, EXCHANGE: true },
            }
        }
        case TradingDeskActionTypes.SUCCESS_EXCHANGE: {
            return {
                ...state,
                loader: { ...state.loader, EXCHANGE: null },
                success: { ...state.success, EXCHANGE: true },
                error: { ...state.success, EXCHANGE: null },
            }
        }
        case TradingDeskActionTypes.FINISH_EXCHANGE: {
            return {
                ...state,
                loader: { ...state.loader, EXCHANGE: null },
                success: { ...state.success, EXCHANGE: null },
                error: { ...state.success, EXCHANGE: null },
            }
        }
        case TradingDeskActionTypes.FAILURE_EXCHANGE: {
            return {
                ...state,
                loader: { ...state.loader, EXCHANGE: null },
                success: { ...state.success, EXCHANGE: null },
                error: { ...state.success, EXCHANGE: true },
            }
        }

        case TradingDeskActionTypes.START_GET_EXCHANGE_RATE: {
            return {
                ...state,
                loader: { ...state.loader, GET_EXCHANGE_RATE: true },
            }
        }
        case TradingDeskActionTypes.SUCCESS_GET_EXCHANGE_RATE: {
            return {
                ...state,
                tradingDeskExchangeRate: action.payload,
                loader: { ...state.loader, GET_EXCHANGE_RATE: null },
                success: { ...state.success, GET_EXCHANGE_RATE: true },
                error: { ...state.success, GET_EXCHANGE_RATE: null },
            }
        }
        case TradingDeskActionTypes.FINISH_GET_EXCHANGE_RATE: {
            return {
                ...state,
                tradingDeskExchangeRate: null,
                loader: { ...state.loader, GET_EXCHANGE_RATE: null },
                success: { ...state.success, GET_EXCHANGE_RATE: null },
                error: { ...state.success, GET_EXCHANGE_RATE: null },
            }
        }
        case TradingDeskActionTypes.FAILURE_GET_EXCHANGE_RATE: {
            return {
                ...state,
                loader: { ...state.loader, GET_EXCHANGE_RATE: null },
                success: { ...state.success, GET_EXCHANGE_RATE: null },
                error: { ...state.success, GET_EXCHANGE_RATE: true },
            }
        }

        case TradingDeskActionTypes.START_GET_EXCHANGE_FEE: {
            return {
                ...state,
                loader: { ...state.loader, GET_EXCHANGE_FEE: true },
            }
        }
        case TradingDeskActionTypes.SUCCESS_GET_EXCHANGE_FEE: {
            return {
                ...state,
                tradingDeskExchangeFee: action.payload,
                loader: { ...state.loader, GET_EXCHANGE_FEE: null },
                success: { ...state.success, GET_EXCHANGE_FEE: true },
                error: { ...state.success, GET_EXCHANGE_FEE: null },
            }
        }
        case TradingDeskActionTypes.FINISH_GET_EXCHANGE_FEE: {
            return {
                ...state,
                tradingDeskExchangeFee: null,
                loader: { ...state.loader, GET_EXCHANGE_FEE: null },
                success: { ...state.success, GET_EXCHANGE_FEE: null },
                error: { ...state.success, GET_EXCHANGE_FEE: null },
            }
        }
        case TradingDeskActionTypes.FAILURE_GET_EXCHANGE_FEE: {
            return {
                ...state,
                loader: { ...state.loader, GET_EXCHANGE_FEE: null },
                success: { ...state.success, GET_EXCHANGE_FEE: null },
                error: { ...state.success, GET_EXCHANGE_FEE: true },
            }
        }
        case TradingDeskActionTypes.SUCCESS_MAX_FEES_V2:
            return {
                ...state,
                maxValueFee: action.payload,
            }
        case TradingDeskActionTypes.FINISH_MAX_FEES_V2:
        case TradingDeskActionTypes.FAILURE_MAX_FEES_V2:
            return {
                ...state,
                maxValueFee: null,
            }

        default:
            return state
    }
}

export default tradingDeskV2Reducer
